import { getMediaMaterialsRank, previewMaterial, changePromotionStatus, updateMaterialField } from '@/api/media-material'
import { getWorkers, getCorporations, getKvData } from '@/api/open'
import { getMedias, getPlatformAppTypes } from '@/api/constant'
import moment from 'moment'
import ShowPromotionPage from '@/views/sys/media-materials-rank/promotion/Promotion.vue'
import DateSelect from '@/components/date-select/DateSelect.vue'
import CreateForm from '@/components/local-material/mediaRecord/create/Create.vue'

export default {
    name: 'mediaMaterialsRank',
    components: {
        ShowPromotionPage,
        DateSelect,
        CreateForm
    },
    model: {
        prop: 'ids',
        event: 'change'
    },
    props: ['ids', 'maxNum', 'media'],
    data() {
        return {
            data: [],
            loading: false,
            medias: [],
            columns: [
                { minWidth: 60, type: 'checkbox' },
                { minWidth: 120, title: '日期', field: 'day' },
                {
                    minWidth: 60, title: '媒体', field: 'media', formatter: item => {
                        return this.$helper.getItemName(this.medias, item.row.media) || '-'
                    },
                },
                { minWidth: 150, title: '视频', slots: { default: 'video_cover' } },
                { minWidth: 170, title: '素材', field: 'material', slots: { default: 'material' } },
                { minWidth: 120, title: '短剧名称', field: 'video_name'},
                { minWidth: 100, title: '消耗', field: 'stat_cost', sortable: true },
                { minWidth: 100, title: '转化数', field: 'convert_cnt', sortable: true },
                { minWidth: 130, title: '转化成本', field: 'conversion_cost', sortable: true },
                { minWidth: 130, title: '付费roi', field: 'pay_amount_roi', sortable: true },
                { minWidth: 90, title: '展示数', field: 'show_cnt', sortable: true },
                { minWidth: 160, title: '千次展现费用', field: 'cpm_platform', sortable: true },
                { minWidth: 90, title: '点击数', field: 'click_cnt', sortable: true },
                { minWidth: 90, title: '点击率', field: 'ctr', sortable: true },
                { minWidth: 100, title: '平均点击', field: 'cpc_platform', sortable: true },
                { minWidth: 90, title: '转化率', field: 'conversion_rate', sortable: true },
                { minWidth: 160, title: '当日广告变现ROI', field: 'attribution_micro_game_0d_roi', sortable: true },
                { minWidth: 160, title: '三日广告变现ROI', field: 'attribution_micro_game_3d_roi', sortable: true },
                { minWidth: 80, title: '是否违规',field: 'is_illegal',  slots: { default: 'is_illegal' } ,fixed: 'right'},
                // { minWidth: 150, title: '操作', slots: { default: 'action' },fixed: 'right', },  

            ],
            model: {},
            materialModel: {},
            queryParam: { 'date': [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')], corporation_id:null },
            channels: [],
            platforms: [],
            showForm: false,
            workers: [],
            tableGrid: this.getTableGrid(),
            preview: {},
            preview_loading: false,
            advertiser_ids: null,
            material_ids: null,
            selectedRowKeys: [],
            corporations: [],
            // appTypes: [
            //     {id:1, name:'微小'},
            //     {id:2, name:'抖小'},
            // ],
            appTypes: [],
            payTypes: [
                {id:1, name:'付费'}, 
                {id:2, name:'免费'}
            ],
            media_corporations: [],
            filteredCorporations: [],  // 过滤后的媒体主体列表
            showPromotionPage: false,
            sum_cost: null,
            showUploadForm: false,
            show: false,
            localIds: this.ids,
            roi: null,
            real_roi: null,

        }
    },
    watch: {
        advertiser_ids(newVal) {
            this.queryParam.advertiser_id = newVal.replace(/\n/g, ',');
        },
        material_ids(newVal) {
            this.queryParam.material_id = newVal.replace(/\n/g, ',');
        },
    },
    mounted() {
        this.localIds = this.filterExpiredLocalIds(this.localIds)
        // console.log('localIds11', this.localIds)
        this.selectedRowKeys = this.localIds.map(item => item.material_id)
        // console.log('selectedRowKeys11', this.selectedRowKeys)
        this.tableGrid.columns = this.columns
        getCorporations().then(res=>{ 
            this.corporations = res.data.list || {}

            this.corporations.sort(function(a, b) {
                return a.id - b.id;
            });
            this.queryParam.corporation_id = this.corporations[0].id

            //此处开始获取kvData
            getKvData({type:2, corporation_id: this.corporations[0].id}).then(res => {
                this.media_corporations = res.data.list || []
                this.filteredCorporations = this.media_corporations
                // this.filteredCorporations = this.media_corporations.map(item => ({ value: item.name }));
            })
        })
        getWorkers().then(res => { this.workers = res.data.list || [] })
        getMedias().then(res => { this.medias = res.data.list || [] })
        getPlatformAppTypes().then(res => {this.appTypes = res.data.list || []})
        this.getData()
    },
    created() { },
    methods: {
        checCheckboxkMethod({ row }) {
            const id = row.material_id
            const isSelected = this.selectedRowKeys.includes(id)
            // 未选中且已达上限时，返回 false（禁用）；否则可选可取消
            return row.media === 2 && (isSelected || this.selectedRowKeys.length < this.maxNum)
        },
        showCheckboxkMethod({ row }) {
            return row.media === 1
        },
        handleRowChange({ checked, row=null }) {
            if (row === null) {
                return
            }
            // 映射选中行的字段
            const mappedRow = this.mappingFields([row])[0]
            if (checked) {
                // 添加选中项
                this.selectedRowKeys.push(mappedRow.material_id)
                this.localIds.push(mappedRow)
            } else {
                // 移除取消选中项
                this.selectedRowKeys = this.selectedRowKeys.filter(id => id !== mappedRow.material_id)
                this.localIds = this.localIds.filter(item => item.material_id !== mappedRow.material_id)
            }
            // console.log('selectedRowKeys222', this.selectedRowKeys)
            // console.log('localIds222', this.localIds)
            this.$emit('change', this.localIds);
        },
        getTableGrid() {
            let grid = this.$helper.tableGrid('mediaMaterialsRank')
            grid.size = 'medium'
            grid.border = 'inner'
            return grid
        },
        edit(record) {
            this.model = Object.assign({}, record)
            this.showForm = true
        },
        getData() {
            if (!this.queryParam.date) {
                return this.$message.error('请选择查询日期')
            }
            // 遍历原始数组，提取material_id
            let materialIds = [];
            this.localIds.forEach(item => {
                if (this.media === 'kuaishou') {
                    materialIds.push(item.material_id);
                } else {
                    // 这里获取的是排行榜的id
                    materialIds.push(item.material_id);
                }
            });
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            json['filter'] = false
            json['current_material_ids'] = materialIds
            json['started_at'] = json.date[0]
            json['finished_at'] = json.date[1]
            delete json.date

            getMediaMaterialsRank(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list
                this.data = res.data.list || []
                this.sum_cost = res.data.cost
                this.roi = res.data.roi
                this.real_roi = res.data.real_roi ? res.data.real_roi : res.data.roi
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = { 'date': [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')], corporation_id:null }
            this.selectedRowKeys = []
            this.getData()
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            // console.log('localIds333', this.localIds)
            // console.log('selectedRowKeys333', this.selectedRowKeys)
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
        accessTo(route) {
            let controller = 'MediaMaterialController'
            if (route.indexOf('@') !== -1) {
                const routeArr = route.split('@')
                controller = routeArr[0]
                route = routeArr[1]
            }
            return this.$helper.accessTo(controller, route)
        },
        showPreview(row) {
            if (row.media === 1) {
                this.preview_loading = true
                this.preview = { url: row.url, 'id': row.material_id }
            } else {
                //获取播放地址
                this.preview_loading = true
                row.id = row.mid
                previewMaterial(row).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.preview = { url: res.data.url, 'id': res.data.mid }
                    } else {
                        this.$message.error(res.message);
                    }
                    this.preview_loading = false
                }).catch(() => {
                    this.preview_loading = false
                })
            }
        },
        leavePreview() {
            this.preview = {}
        },
        changeAdStatus(id, enabled, refresh) {
            if (this.queryParam.stat_day < '2023-11-16') {
                return this.$message.error('只能操作2023-11-15号后之后的数据')
            }
            const update = ids => {
                changePromotionStatus(ids, { 'status': enabled }).then(() => {
                    if (refresh) {
                        this.$message.destroy()
                        this.$message.success('操作成功')
                        this.refresh()
                    }
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            }
            if (!id) {
                const actionType = enabled === 'ENABLE' ? '启用' : '暂停'
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要{actionType} {this.selectedRowKeys.length} 条广告吗?</div>,
                    onOk: () => {
                        update(this.selectedRowKeys, enabled)
                    }
                })
            }
            update([id])
        },
        changeCorporation () {
            getKvData({type:2, corporation_id: this.queryParam.corporation_id}).then(res => {
                this.media_corporations = res.data.list || []
                this.changeMediaCorporation(this.queryParam.advertiser_name)
            })
        },
        changeMediaCorporation(value) {
            // 如果用户输入了内容，则按输入内容进行过滤
            if (value) {
              this.filteredCorporations = this.media_corporations
                .filter(item => item.includes(value));  // 直接过滤字符串数组
            } else {
              // 如果没有输入，则展示所有选项
              this.filteredCorporations = [...this.media_corporations]; // 显示全部选项
            }

        },
        
        showPromotions (row) {
     
            const json = {
                ...this.queryParam,      // 展开 this.queryParam 对象的所有属性
                // date: this.queryParam.date,
                show_name: row.name,
                // corporation_id: this.queryParam.corporation_id,
                material_id: row.material_id,
                // advertiser_name: this.queryParam.material_id,
            }
           
            delete json.page
            delete json.page_size
            delete json.sort_field
            this.model = Object.assign({}, json)
            this.showPromotionPage = true
        },
        changePayType () {
            if (this.queryParam.corporation_id) {
                //修改付费类型，改变媒体主体
                getKvData({type:2, corporation_id: this.queryParam.corporation_id, flag: this.queryParam.pay_type === 2? 'free' : ''}).then(res => {
                    this.media_corporations = res.data.list || []
                    this.filteredCorporations = this.media_corporations
                })
            }
        },
        uploadToMedia (record) {
            // console.log(record)
            this.showUploadForm = true
            this.materialModel = {
                media_name: '巨量',
                mediaStr: 'juliang',
                up_type: 3,
                advertiser_id: null,
                material_id: record.material_id,
                material_advertiser_id: record.advertiser_id,
            }
        },
        mappingFields(records) {
            return records.map(item => ({
                id:          item.media_material_out_id,
                url:         item.url,
                ratio:       item.ratio,
                width:       item.width,
                height:      item.height,
                filename:    item.name,
                poster_url:  item.new_video_cover,
                material_id: item.material_id,
            }))
        },
        close() {
            this.$emit('change', Object.assign([], this.localIds))
            this.show = false
        },
        clearSelected () {
            const grid = this.$refs.xGrid
            if (grid) {
                // 清除跨页保留 & 本页勾选
                grid.clearCheckboxReserve();
                grid.clearCheckboxRow();
            }
            this.localIds = []
            this.selectedRowKeys = []
            this.$emit('change', [])
            this.show = false
        },
        filterExpiredLocalIds(ids) {
            const currentTimestamp = Math.floor(Date.now() / 1000);
            return ids.filter(item => {
                if (!item.poster_url) return true; // poster_url 不存在时直接返回 true
                try {
                    const urlObj = new URL(item.poster_url);
                    const expires = urlObj.searchParams.get("x-expires");
                    // 未获取到 x-expires 时，可选择保留该项（或按需求剔除）
                    if (!expires) return true;
                    return parseInt(expires, 10) > currentTimestamp;
                } catch (e) {
                    console.error("无法解析 poster_url:", item.poster_url, e);
                    // 解析失败时剔除该数据项
                    return false;
                }
            })
        },
        handleCheckboxAll({ checked, records }) {
            const grid = this.$refs.xGrid
            // 清除跨页保留 & 本页勾选
            grid.clearCheckboxReserve()
            grid.clearCheckboxRow()
            this.selectedRowKeys = []
            this.localIds = []
            if (checked) {
                // 映射选中行的字段
                const mappedRecords = this.mappingFields(records)
                // 限制选中数量
                const limitedRecords = mappedRecords.slice(0, this.maxNum)
                this.selectedRowKeys = limitedRecords.map(item => item.material_id)
                this.localIds = limitedRecords;

                grid.setCheckboxRow(limitedRecords, true);
            }
            this.$emit('change', this.localIds);
        },
        updateMaterialField(id, is_illegal, field, refresh) {
            this.tableGrid.loading = true
            const update = ids => {
                const data = {
                    id: ids,
                    field: field,
                    value: is_illegal
                }
                updateMaterialField(data).then(() => {
                    if (refresh) {
                        this.$message.destroy()
                        this.$message.success('操作成功')
                        this.refresh()
                    }
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            }
            if (!id) {
                const actionType = is_illegal ? '是' : '否'
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要{actionType} {this.selectedRowKeys.length} 条广告主吗?</div>,
                    onOk: () => {
                        update(this.selectedRowKeys)
                    }
                })
            }
            update([id])
        },
    }
}
